import React from "react";
import { DownloadIcon } from "lucide-react";
import { heroEyebrow, heroFeatures, images, product } from "../data/product";
import { CtaButton } from "./ui/CtaButton";
import { Disclosure } from "./ui/Disclosure";
import { ImageSlot } from "./ui/ImageSlot";
export function Hero() {
  return <section id="top" className="bg-cream pb-12 lg:py-16" data-id="element-106" data-mp="4m8mecr76rkx">
      <div className="mx-auto grid max-w-6xl lg:grid-cols-2 lg:items-start lg:gap-14 lg:px-6" data-id="element-107" data-mp="4jm6npu5l5rm">
        <div className="lg:sticky lg:top-24" data-id="element-108" data-mp="127eeddqu7pdg">
          <ImageSlot src={images.heroBundle} alt="Il bundle: 6 volumi digitali di ricette, 5 bonus e cosmetici naturali fatti in casa" placeholderLabel="Mockup principale del bundle" className="aspect-[4/3] w-full shadow-[0_18px_40px_-24px_rgba(86,18,54,0.45)] lg:rounded-[28px]" data-id="element-109" data-mp="xa4h5bx7i9f2" />
        </div>

        <div className="px-4 pt-7 sm:px-6 lg:px-0 lg:pt-2" data-id="element-110" data-mp="3czfm01cr0b73">
          <p className="mb-3 text-[12px] font-semibold uppercase leading-snug tracking-[0.12em] text-terracotta sm:text-[13px]" data-id="element-111" data-mp="381e61pamcrzu">
            {heroEyebrow}
          </p>
          <h1 className="font-serif text-[32px] font-semibold leading-[1.1] text-wine sm:text-[42px] lg:text-[50px]" data-id="element-112" data-mp="3o7c4291259lw">
            Crea i tuoi cosmetici
            <span className="block italic text-rose" data-id="element-113" data-mp="39a36uyp2pbm9">— direttamente a casa</span>
          </h1>
          <p className="mt-4 text-[17px] leading-relaxed text-ink sm:text-lg" data-id="element-114" data-mp="3e7uzxw1gf3s1">
            Oltre 600 ricette per imparare a realizzare i tuoi prodotti per la cura della persona, anche se parti da
            zero. Tutto organizzato in 6 volumi digitali, con istruzioni passo dopo passo e 5 bonus inclusi.
          </p>
          <p className="mt-4 text-[16px] leading-relaxed text-ink" data-id="element-115" data-mp="2qhqwpps6h61k">
            In ogni ricetta trovi{" "}
            <strong className="font-semibold text-wine" data-id="element-116" data-mp="2vglkl6505ksj">grammi esatti, percentuali e durata di conservazione</strong>.
            Niente “un cucchiaio di questo e una tazza di quello”.
          </p>

          <div className="mt-5 flex items-start gap-3 rounded-2xl bg-chip/60 px-4 py-3.5" data-id="element-117" data-mp="2lml98mj4njbd">
            <DownloadIcon className="mt-0.5 h-5 w-5 shrink-0 text-wine" strokeWidth={1.75} aria-hidden="true" data-id="element-118" data-mp="s3uq3ug3l49k" />
            <p className="text-[15px] leading-snug text-ink" data-id="element-119" data-mp="ic86patlvyvq">
              <strong className="font-semibold text-wine" data-id="element-120" data-mp="icrmolzp4d74">Cosa ricevi:</strong> {product.volumesCount} volumi digitali
              con {product.recipesText} ricette + {product.bonusCount} guide bonus, via email subito dopo l'acquisto.
            </p>
          </div>

          <div className="mt-6 border-t border-line" data-id="element-121" data-mp="161jcj6ptcjgq">
            {heroFeatures.map(f => <Disclosure key={f.title} title={f.title} data-id="element-122" data-mp="111ycsu2tk72y">
                {f.body}
              </Disclosure>)}
          </div>

          <div className="mt-8 flex flex-col items-center gap-3 sm:items-start" data-id="element-123" data-mp="x0uxc8oood29">
            <CtaButton data-id="element-124" data-mp="3ltqc7blwotsz">Scopri il bundle completo · {product.price}</CtaButton>
            <p className="text-sm text-muted" data-id="element-125" data-mp="3hr3rrvrkeb5t">Pagamento unico · Accesso immediato</p>
          </div>
        </div>
      </div>
    </section>;
}